export default __webpack_public_path__ + "static/media/image2.d0c8b480.png";